import React from 'react';

const HomePage = () => (
  <div className="page-content">
    <p>Hello and Welcome to my site. Here you will find my basic profile and some random content. Enjoy your stay!</p>
    <img id="welcome-img" src="/img/welcome.jpg" alt="welcome" />
	</div>
);

export default HomePage;
